<template>
    <MaskInput convertType="text"
               class="input-text-scv searchIcon"
               :strReplacePlaceholder="strReplacePlaceholder" />
</template>

<script lang="ts">
    import { Options, Vue } from "vue-class-component";
    import MaskInput from "@/components/Input/MaskInput.vue";

    @Options({
        components: {
            MaskInput,
        },
        props: {
            strReplacePlaceholder: { type: String, require: false, default: "検索キーワードを入力" },
        }
    })

    /**
     * 検索アイコン付きエディットボックス（ただのMaskInputの拡張）
     */
    export default class SearchInput extends Vue {
    }
</script>

<style scoped>
    /* 虫眼鏡アイコン */
    .searchIcon {
        padding-left: 32px !important;
        background-image: url('../../assets/img/search_gy.svg');
        background-repeat: no-repeat;
        background-position: left 4px center;
        background-color: rgba(255, 255, 255, 0.4);
        background-blend-mode: lighten;
    }

    /* 虫眼鏡アイコン(フォーカス) */
    .searchIcon:focus {
        background-blend-mode: luminosity;
    }
</style>
